import React from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing'
import GoogleSecurityCommandCenterCredentialsForm from './GoogleSecurityCommandCenterCredentialsForm'
import GoogleSecurityCommandCenterMappingForm from './GoogleSecurityCommandCenterMappingForm'

function GoogleSecurityCommandCenterConfigListing(props) {
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={GoogleSecurityCommandCenterMappingForm}
            CredentialsForm={GoogleSecurityCommandCenterCredentialsForm}
            componentName="Organization"
            componentKey="organization_name"
        />
    )
}

export default GoogleSecurityCommandCenterConfigListing
